export function computeAutoselectDashboardQueryString(): string {
    return `?autoselect_dashboard=${getAutoselectDashboardParam()}`;
}

export function getAutoselectDashboardParam(): string {
    const params = new URLSearchParams(window.location.search);

    if (!params.has('autoselect_dashboard')) {
        return 'login';
    }

    return `${encodeURIComponent(params.get('autoselect_dashboard') || '')}`;
}
